import { createFileRoute } from '@tanstack/react-router';

import { OnboardingWizard } from '@/features/profiles/onboarding-page';
import type { OnboardingFlow } from '@/lib/api/profiles';

export const Route = createFileRoute('/_app/onboarding/$flow')({ component: OnboardingRoute });

function OnboardingRoute() {
  const { flow } = Route.useParams();
  return <OnboardingWizard flow={flow as OnboardingFlow} />;
}
